import React from "react";
import ReactDOM from "react-dom/client";

import { GlobalStyles } from "./Global/GlobalStyles";
import { ThemeProvider } from "styled-components";
import { Theme } from "./Global/Theme";
import { Home } from "./components/Pages/home";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ContextProvider } from "./context/Context";
import { OfflineSystem } from "./components/Pages/ offlineSystem";
import { NotFound } from "./components/Pages/notFound";
import { TermsOfUse } from "./components/Pages/TermsOfUse";
import { PrivacyPolicy } from "./components/Pages/PrivacyPolicy";
import { Complaint } from "./components/Pages/complaint/complaint";
import "react-toastify/dist/ReactToastify.css";
import { WorkWithUs } from "./components/Pages/ workWithUs/ workWithUs";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const RedirectToLoginCadastro: React.FC = () => {
  window.location.replace(
    "https://mapa.starcheck.com.br/agendamento/login-cadastro"
  );
  return null;
};
const RedirectToAgendamento: React.FC = () => {
  window.location.replace("https://mapa.starcheck.com.br/agendamento");
  return null;
};

root.render(
  <React.StrictMode>
    <ThemeProvider theme={Theme}>
      <ToastContainer autoClose={2000} />
      <GlobalStyles />
      <ContextProvider>
        <BrowserRouter>
          <Routes>
            {/*<Route path="/" element={<Navigate to={"/offline"} />} />*/}

            <Route path="/" element={<Home />} />
            <Route path="*" element={<NotFound />} />
            <Route path="termos-de-uso" element={<TermsOfUse />} />
            <Route path="trabalhe-conosco" element={<WorkWithUs />} />
            <Route path="politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="denuncia" element={<Complaint />} />
            <Route path="/offline" element={<OfflineSystem />} />
            <Route
              path="login-cadastro"
              element={<RedirectToLoginCadastro />}
            />
            <Route
              path="agendamento"
              element={<RedirectToAgendamento />}
            ></Route>
          </Routes>
        </BrowserRouter>
      </ContextProvider>
    </ThemeProvider>
  </React.StrictMode>
);
